export const TABS = {
  OPERATORS: 'operators',
  SSO: 'sso',
};
